<!-- a hidden div is created to set the position of appearance of the menu-->
<div
  style="visibility: hidden; position: fixed"
  [style.left]="menuTopLeftPosition.x"
  [style.top]="menuTopLeftPosition.y"
  [matMenuTriggerFor]="rightMenu"
></div>

<!-- standard material menu for the context-menu -->
<mat-menu #rightMenu="matMenu">
  <ng-template matMenuContent let-item="item">
    <input [formControl]="searchContextMenuControl" id="filter-menu-id" mat-menu-item placeholder="Search..." type="text" mat-input/>
    <div *ngFor="let menuItem of contextMenuList">
    <div [hidden]="contextMenuSearchText.length > 1 && !isInFilter(menuItem.name)">
      <button (click)="addColumnPlaceholder(menuItem)" id="test" autofocus="false" mat-menu-item >
        {{ menuItem.name }} 
    </button>
    </div>
  </div>
  </ng-template>
</mat-menu>

<div class="section-header">
  <span>Mapping Rule</span>
</div>
<form [formGroup]="form">
  <div class="form-field full-width">
    <mat-form-field class="lc-form-field" appearance="outline">
      <label>Target path</label>
      <input matInput formControlName="targetPath" />
      <mat-error *ngIf="isFormControlInvalid('targetPath')">
        {{ getErrorMessage("targetPath") }}
      </mat-error>
    </mat-form-field>
  </div>

  <div class="form-field full-width">
    <mat-form-field class="lc-form-field" appearance="outline">
      <label>Mapping</label>
      <mat-select (selectionChange)="validateRulePlaceholdersOnMappingChange()" formControlName="mappingId">
        <mat-option *ngFor="let mapping of mappings" [value]="mapping.id">
          {{ mapping.name }}
        </mat-option>
      </mat-select>
      <mat-error *ngIf="isFormControlInvalid('mappingId')">
        {{ getErrorMessage("mappingId") }}
      </mat-error>
    </mat-form-field>
  </div>

  <div class="form-field full-width">
    <mat-form-field class="lc-form-field" appearance="outline">
      <label>Mapping rule</label>
      <textarea id="rule-textarea" #ruleTextarea
        (keydown)="openContextMenu($event)"
        (ngModelChange)="validateRulePlaceholders($event)"
        matInput
        formControlName="rule"
      ></textarea>
    </mat-form-field>
    <div class ="nonColumnValues">
      <mat-hint *ngIf="nonColumnValuesExist()"> 
        The following values are not identified as column names: 
        <span *ngFor="let value of this.ruleNonColumnValues">
          {{value+","}}
        </span>  
      </mat-hint>
    </div>
  </div>

  <div class="form-field full-width">
    <mat-form-field class="lc-form-field" appearance="outline">
      <label>Additional properties</label>
      <input matInput formControlName="additionalProperties" />
    </mat-form-field>
  </div>

  <div class="form-field full-width">
    <mat-form-field class="lc-form-field" appearance="outline">
      <label>Additional condition</label>
      <input matInput formControlName="additionalCondition" />
    </mat-form-field>
  </div>
</form>

<div id="footer-buttons-container">
  <button
    mat-stroked-button
    class="lc-stroked-button-no-margin lc-primary"
    (click)="save()"
    [disabled]="!canSave()"
  >
    <mat-icon svgIcon="tick"></mat-icon>Save
  </button>
  <button
    mat-stroked-button
    class="lc-stroked-button-no-margin lc-primary"
    (click)="cancel()"
  >
    <mat-icon svgIcon="close"></mat-icon>Cancel
  </button>
</div>
